import React, { useState } from 'react'
import qs from 'query-string';
import { Redirect } from 'react-router-dom'
import { Card, Col, Image, Row, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './RegistroBridge.css';
import ByPactopia from '../ByPactopia';
import { HaveAnAccount } from './HaveAnAccount';

const RegistroBridge = (props) => {
  const [page, setPage] = useState();
  const [moreOptions, setMoreOptions] = useState(false);

  const query = qs.parse(props.location.search);

  const { tenancy } = query;

  const toggleMoreOptions = () => setMoreOptions((value) => !value)

  const renderMainOptions = () => {
    return (
      <>
        <Row>
          <Col>
            Antes de crear tu cuenta queremos conocer qué uso quieres darle a nuestra plataforma.
            <br />
            <br />
            ¿Qué necesitas? Elige una opción.
          </Col>
        </Row>

        <Row className="mt-4 wizard-card-option"
          aria-label="Crear cuenta de emisión"
          role="button"
          onClick={() => setPage(`/auth/registro/simple${tenancy ? '?tenancy=' + tenancy : ''}`)}
        >
          <Col>
            <Card>
              <Card.Header className="card-header-option">
                <strong>Crear facturas</strong>
              </Card.Header>
              <Card.Body className="pt-0">
                Voy a emitir facturas a mis clientes o soy contador y quiero emitir facturas a nombre de mis contribuyentes.
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row className="my-4 wizard-card-option"
          aria-label="Crear cuenta de consulta de facturas"
          role="link"
          onClick={toggleMoreOptions}
        >
          <Col>
            <Card>
              <Card.Header className="card-header-option">
                <strong>Consultar tus CFDI</strong>
              </Card.Header>
              <Card.Body className="pt-0">
                Soy empleado o cliente de una empresa y solo deseo <strong>descargar</strong> las <strong>Facturas</strong> o <strong>Recibos de Nómina</strong> que me han emitido.
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </>
    )
  }

  const renderMoreOptions = () => {
    return (
      <>
        <Row>
          <Col>
            <br />
            ¿Qué tipo de usuario eres? Elige una opción.
          </Col>
        </Row>

        <Row className="mt-4 wizard-card-option"
          aria-label="Crear cuenta de emisión"
          role="button"
          onClick={() => setPage(`/auth/external?tipo=empleado${tenancy ? '&tenancy=' + tenancy : ''}`)}
        >
          <Col>
            <Card>
              <Card.Header className="card-header-option">
                <strong>Empleado</strong>
              </Card.Header>
              <Card.Body className="pt-0">
                Quiero descargar los <strong>Recibos de Nómina</strong> que me han emitido.
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row className="my-4 wizard-card-option"
          aria-label="Crear cuenta de consulta de facturas"
          role="button"
          onClick={() => setPage(`/auth/external?tipo=cliente${tenancy ? '&tenancy=' + tenancy : ''}`)}
        >
          <Col>
            <Card>
              <Card.Header className="card-header-option">
                <strong>Cliente</strong>
              </Card.Header>
              <Card.Body className="pt-0">
                Quiero descargar las facturas que me han emitido.
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </>
    )
  }

  if (page) {
    return (
      <Redirect to={page} />
    )
  }

  if (!query.w) {
    return (
      <Redirect to={`/auth/registro/simple${tenancy ? '&tenancy=' + tenancy : ''}`} />
    )
  }

  return (
    <div className="auth-content RegistroBridge">
      { !!moreOptions && (
          <div className="mt-5">
            <Button variant="link" size="md" className="pl-0" onClick={toggleMoreOptions}>
              <FontAwesomeIcon icon={ ['fas', 'chevron-left'] } />
              { ' ' } Regresar
            </Button>
          </div>
        )
      }
      { !moreOptions && (
        <div className="avatar mt-4">
          <div className="auth-logo">
            <div className="d-flex justify-content-start">
                <Image src="/img/logo.png"
                  className="auth-logo-img opacity-6"
                  fluid={ true }
                />
                <p className="title text-muted">Facturotöpia</p>
            </div>
          </div>
        </div>
      )}

      {!moreOptions && renderMainOptions()}

      {moreOptions && renderMoreOptions()}

      <HaveAnAccount tenancy={tenancy} />

      <ByPactopia />
    </div>
  )
}

export default RegistroBridge;